<section class="basic-info">
  <div class="basic-info-upper">
    <figure class="icon">
      <img
        *ngIf="userImage; else none"
        src="data:image/png;base64,{{ userImage }}"
        alt="{{ userBasicInfo.family }}{{ userBasicInfo.given }}"
        width="56"
        height="56"
      />
      <ng-template #none>
        <mat-icon svgIcon="user-avatar"></mat-icon>
      </ng-template>
    </figure>
    <div class="info">
      <dl>
        <dt class="title">個人番号</dt>
        <dd class="info-data">{{ userBasicInfo.daicd }}</dd>
      </dl>
      <dl>
        <dt class="title">フリガナ</dt>
        <dd class="info-data">
          {{ userBasicInfo.kanafamily }}{{ userBasicInfo.kanagiven }}
        </dd>
      </dl>
      <dl>
        <dt class="title">氏名</dt>
        <dd class="info-data">
          {{ userBasicInfo.family }}{{ userBasicInfo.given }}
        </dd>
      </dl>
      <dl>
        <dt class="title">ニックネーム</dt>
        <dd class="info-data">{{ userBasicInfo.nicknm }}</dd>
      </dl>
      <dl>
        <dt class="title">性別</dt>
        <dd class="info-data">{{ sex }}</dd>
      </dl>
      <dl>
        <dt class="title">郵便番号</dt>
        <dd class="info-data">{{ zipcode }}</dd>
      </dl>
      <dl>
        <dt class="title">住所</dt>
        <dd class="info-data">{{ userBasicInfo.addr }}</dd>
      </dl>
      <dl>
        <dt class="title">電話番号</dt>
        <dd class="info-data" *ngIf="telToCall === ''">{{ tel }}</dd>
        <a [href]="telToCall" *ngIf="telToCall !== ''" target="_blank" rel="noopener noreferrer" class="info-data phone-link">{{ tel }}</a>
      </dl>
      <dl>
        <dt class="title">生年月日</dt>
        <dd class="info-data">
          {{ jaCalendar(userBasicInfo.birth) }}
        </dd>
      </dl>
      <dl>
        <dt class="title">年齢</dt>
        <dd class="info-data">{{ age }}</dd>
      </dl>
    </div>
  </div>
  <div class="border-line"></div>
  <div class="basic-info-lower">
    <dl>
      <dt class="title">終結日</dt>
      <dd class="info-data">
        {{ userBasicInfo.enddate | date: "yyyy年M月d日" }}
      </dd>
    </dl>
    <dl>
      <dt class="title">終結理由</dt>
      <dd class="info-data">{{ userBasicInfo.endriyu }}</dd>
    </dl>
  </div>
</section>
